import { render, staticRenderFns } from "./icon-base.vue?vue&type=template&id=5332f273&scoped=true&"
import script from "./icon-base.vue?vue&type=script&lang=js&"
export * from "./icon-base.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5332f273",
  null
  
)

export default component.exports